import { Pipe, PipeTransform } from '@angular/core';
import { formatComplianceFileName } from '../utils/compliance-file-name.util';

@Pipe({
  name: 'customComplianceName',
  standalone: true,
})
export class CustomComplianceNamePipe implements PipeTransform {
  transform(value: string): string {
    return formatComplianceFileName(value);
  }
}
